function initValueProps() {
  const $valuePropSections = document.querySelectorAll('.value-props');

  $valuePropSections.forEach($section => {
    // Clear any existing interval
    if ($section.valuePropsInterval) {
      clearInterval($section.valuePropsInterval);
    }

    const children = Array.from($section.children);
    // Since the first item is already active in the HTML, start with the next index.
    let currentIndex = 1;
    
    // Optionally, ensure a clean state (first child is active)
    children.forEach(child => child.classList.remove('active'));
    if (children[0]) {
      children[0].classList.add('active');
    }
    
    // Start the interval and attach the ID to the section element
    $section.valuePropsInterval = setInterval(() => {
      children.forEach(child => child.classList.remove('active'));
      children[currentIndex].classList.add('active');
      currentIndex = (currentIndex + 1) % children.length;
    }, 4000);
  });
}

// Clears the rotation and resets classes
function teardownValueProps() {
  const $valuePropSections = document.querySelectorAll('.value-props');
  $valuePropSections.forEach($section => {
    if ($section.valuePropsInterval) {
      clearInterval($section.valuePropsInterval);
      $section.valuePropsInterval = null;
    }
    Array.from($section.children).forEach(child => child.classList.remove('active'));
  });
}

// Checks the window width and either initializes or tears down the rotation
function checkValueProps() {
  if (window.innerWidth < 512) {
    initValueProps();
  } else {
    teardownValueProps();
  }
}

// Initial check
checkValueProps();

// Re-check on window resize
window.addEventListener('resize', checkValueProps);
